import { Injectable } from '@angular/core';
import { UserDevicesIntl } from '@ebootis/login';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
	providedIn: 'root'
})
export class UserDevicesI18n extends UserDevicesIntl {

	public constructor(
		private m_translateService: TranslateService
	) {
		super();
		this.m_translateService.onLangChange.subscribe({
			next: (e: Event) => {
				this.getAndInitTranslations();
			}
		});
		this.getAndInitTranslations();
	}

	private getAndInitTranslations(): void {
		this.m_translateService.get('SETTINGS.UI.DEVICES.TITLE.TEXT').subscribe({
			next: (res: string) => {
				this.titleText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('USER.DEVICES.UI.TABLE.DEVICE_NAME.TEXT').subscribe({
			next: (res: string) => {
				this.deviceNameText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('USER.DEVICES.UI.TABLE.VERIFICATION_DATE.TEXT').subscribe({
			next: (res: string) => {
				this.verificationDateText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('USER.DEVICES.UI.TABLE.LAST_LOGIN.TEXT').subscribe({
			next: (res: string) => {
				this.lastLoginText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('USER.DEVICES.UI.TABLE.REMOVE.TEXT').subscribe({
			next: (res: string) => {
				this.removeText = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('GLOBAL.BUTTON.REMOVE.TOOLTIP').subscribe({
			next: (res: string) => {
				this.removeTooltip = res;
				this.changes.next(null);
			}
		});

		this.m_translateService.get('USER.DEVICES.UI.NO_DATA.TEXT').subscribe({
			next: (res: string) => {
				this.noDataText = res;
				this.changes.next(null);
			}
		});
	}
}
